<template>
	<div class="layout">
		<div id="print-code-content">
		</div>
		<div class="print-config">
			<div class="print-config-title">
				<div class="print-config-title-left">
					打印设置
				</div>
				<div class="print-config-title-right">
					<button class="jxyd-button jxyd-primary" @click="print">打印</button>
					<!-- <button class="jxyd-button" @click="templateSetting">模版设置</button> -->
				</div>
			</div>
			<div class="print-config-content">
				<div class="field-list">
					<CheckboxGroup style="margin-top: 20px;" v-model="printConfig.selected">
						<div class="field-list-title">
							勾选需要打印的字段
						</div>
						<div class="field-list-item" v-for="(item,index) in printData.attributes" :key="index">
							<Checkbox :label="item.name">
								{{item.displayName}}
							</Checkbox>
						</div>
					</CheckboxGroup>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import jsBarcode from 'jsbarcode';
	export default {
		name: 'printercodepage',
		data() {
			return {
				printConfig: {
					attributes: [],
					selected: []
				},
				printData: []
			}
		},
		created() {},
		watch: {
			printConfig: {
				deep: true,
				handler(param) {
					if (param) {
						this.initPrintContext(this.printData.printData);
						localStorage.setItem('_printConfig' + this.printData.name, JSON.stringify(this.printConfig));
					}
				}
			},
			'$route': {
				immediate: true,
				handler(param) {
					if (param) {
						this.initPage();
					}
				}
			}
		},
		methods: {
			initPage() {
				let printData = JSON.parse(localStorage.getItem("_printData"));
				if (printData) {
					this.printData = printData;
					localStorage.removeItem("_printData");
				}
				let data = localStorage.getItem('_printConfig' + this.printData.name)
				if (data) {
					this.printConfig = JSON.parse(data)
				} else {
					this.printConfig.selected = []
					this.printConfig.attributes = []
					for (let i = 0; i < this.printData.attributes.length; i++) {
						if (i <= 4) {
							this.printConfig.selected.push(this.printData.attributes[i].name)
						}
						this.printConfig.attributes.push(this.printData.attributes[i]);
					}
				}
			},
			initPrintContext(data) {
				let printHtml = '';
				for (var f = 0; f < data.length; f++) {
					printHtml +=
						'<div class="print-item">';
					for (let i = 0; i < this.printConfig.selected.length; i++) {
						if (data[f][this.printConfig.selected[i]]) {
							printHtml += '<div style="margin-bottom: 10px;">';
							printHtml += '<span style="font-weight: bold;">' + this.printConfig.attributes[i].displayName +
								':</span>';
							printHtml += '<span>' + data[f][this.printConfig.selected[i]] + '</span>';
							printHtml += '</div>';
						}
					}
					printHtml += `<img id="imgcode${data[f].id}" style='width:100%;height:60px;'/>`;
					printHtml += '</div>';
				}
				this.$nextTick(() => {
					document.getElementById('print-code-content').innerHTML = printHtml;
				})
				let self = this;
				setTimeout(function() {
					self.initPrintCode(data);
				}, 300)
			},
			initPrintCode(data) {
				let option;
				data.forEach((item, index) => {
					option = {
						text: item.code, //等同于JsBarcode第二个参数 
						fontSize: 10, //条形码下方文字的大小
						height: 60, //条形码的高度
						width: 2.5, //条形码 条的宽度不是总体的宽度 (宽度过小 扫描枪会扫描不出来 天坑我踩过)
						displayValue: false, //隐藏条形码下方文本
					};
					JsBarcode(`#imgcode${data[index].id}`, '5', option);
				});
			},
			print() {
				window.print();
			},
			templateSetting(){
				this.$router.push({
					path: 'printtemplatesettings'
				});
			}
		}
	}
</script>

<style>
	.layout {
		overflow: hidden;
	}

	#print-code-content {
		width: 70%;
		float: left;
		padding: 0px 20%;
	}

	.print-config {
		float: left;
		width: 29%;
		margin-left: 1%;
	}

	.print-config-title {
		background-color: white;
		border-radius: 30px;
		padding: 10px;
		margin-bottom: 10px;
		border-left: 3px solid rgb(255, 106, 127);
		color: #000;
		font-weight: bold;
		overflow: hidden;
	}

	.print-config-title-left {
		float: left;
		line-height: 32px;
		height: 32px;
	}

	.print-config-title-right {
		float: right;
	}

	.print-config-content {
		background-color: white;
		padding: 10px;
		border-radius: 10px;
	}

	.field-list-title {
		margin-bottom: 10px;
		color: #000;
		border-left: 3px solid rgb(255, 106, 127);
		padding-left: 5px;
	}

	.field-list-item {
		font-size: 8px;
		margin-bottom: 10px;
	}

	.print-item {
		padding: 20px;
		margin-bottom: 20px;
		font-size: 14px;
		background-color: white;
	}
	
	/* 隐藏页面上的所有元素 */
	@media print {
		#app * {
			display: none;
		}

		.index-vue,
		.sec-right,
		.main-content,
		.view-c,
		.layout {
			display: block !important;
			margin: 0px !important;
			height: auto !important;
			min-height: auto !important;
		}

		#print-code-content {
			display: block !important;
			margin: 0px !important;
			padding: 0px;
		}

		.print-item {
			display: block !important;
			width: 200px !important;
			height: 200px;
			page-break-after: always;
			padding: 0px;
		}

		.print-item div {
			display: block !important;
			margin-bottom: 6px !important;
		}
		
		.print-item div span{
			display: inline !important;
		}
		
		.print-item img{
			display: block !important;
			width:100%;
			height:100px;
		} 
	}
</style>